import React from "react";

const Facebook = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_164_666)">
      <path
        d="M20.6997 10.3498C20.6997 4.63383 16.0658 0 10.3498 0C4.63383 0 0 4.63383 0 10.3498C0 15.2035 3.34175 19.2764 7.84973 20.395V13.5127H5.71559V10.3498H7.84973V8.98697C7.84973 5.4643 9.44402 3.83151 12.9025 3.83151C13.5583 3.83151 14.6897 3.96026 15.1526 4.0886V6.9555C14.9083 6.92984 14.484 6.917 13.957 6.917C12.26 6.917 11.6042 7.55993 11.6042 9.23123V10.3498H14.9849L14.4041 13.5127H11.6042V20.6239C16.7291 20.005 20.7001 15.6415 20.7001 10.3498H20.6997Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_164_666">
        <rect width="20.6997" height="20.6997" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

Facebook.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};
export default Facebook;
